export default {
    id: "ID"
}